import { Injectable } from '@angular/core';
import { GenericUtilityService } from '../generic/generic-utility.service';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
const baseApiOCR = environment.baseAPIOCR;
const baseApiOCRNew = environment.baseAPIOCRNew;
@Injectable({
  providedIn: 'root'
})
export class InsuranceService {
  progress$: any;
  private progressObserver: any;
  private progress: any;
  
  constructor(private GenericUtility: GenericUtilityService) { }
  SearchPatientInsurance(searchinsurancemodel: any) {
    return this.GenericUtility.ApiPostMethodTalkphr("TalkCheckin", "SearchPatientInsurance", searchinsurancemodel);
  }
  GetPatientInsuranceInfo(patientAccount: any, practiceCode: any, appointmentId:any) {
    return this.GenericUtility.ApiGetMethodTalkphr("TalkCheckin/GetPatientInsuranceInfo?PracticeCode=" + practiceCode + '&PatientAccount=' + patientAccount + '&AppointmentId=' + appointmentId);
  }
  UpdatePatientInsurance(updateinsurancemodel: any) {
    return this.GenericUtility.ApiPostMethodTalkphr("TalkCheckin", "UpdatePatientInsurance", updateinsurancemodel);
  }
  AddPatientInsurance(addinsurancemodel: any) {
    return this.GenericUtility.ApiPostMethodTalkphr("TalkCheckin", "AddPatientInsurance", addinsurancemodel);
  }
  async AddSubscriber(_updatesubscriberinfo: any) {
    return await this.GenericUtility.ApiPostMethodTalkphr("TalkCheckin", "AddUpdateSubscriber", _updatesubscriberinfo).toPromise();
  }
  GetSubscriberDetails(practiceCode: any, patientAccount: any, GuarantorCode: any) {
    return this.GenericUtility.ApiGetMethodTalkphr("TalkCheckin/GetSubscriberDetails?PracticeCode=" + practiceCode + '&PatientAccount=' + patientAccount + '&GuarantorCode=' + GuarantorCode);
  }
  OcrInsurance(files:any)
  {
    
    return Observable.create((observer:any) => {
      
      let formData: FormData = new FormData(),
      xhr: XMLHttpRequest = new XMLHttpRequest();
      
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            observer.next(JSON.parse(xhr.response));
            observer.complete();
          } else {
            observer.error(xhr.response);
          }
        }
      };
      
      xhr.upload.onprogress = (event) => {
        this.progress = Math.round(event.loaded / event.total * 100);
        if (this.progressObserver)
        this.progressObserver.next(this.progress);
      };
      
      
      xhr.open('POST', baseApiOCR, true);
      
      
      if(files == null){
        formData.append("file[]" , "");
      } else {
        let i=0;
        Array.from(files).forEach((file:any) => 
        {
          if(file.type.includes("png"))
          formData.append('file[]', file,'ocr'+i+'.png');
          else
          if(file.type.includes("jpg"))
          formData.append('file[]', file,'ocr'+i+'.jpg');
          else
          if(file.type.includes("jpeg"))
          formData.append('file[]', file,'ocr'+i+'.jpeg');
          //else
          // if(file.type.includes("jpg"))
          // formData.append('file[]', file,'ocr'+i+'.jpg');
          // else
          // if(file.type.includes("jpg"))
          // formData.append('file[]', file,'ocr'+i+'.jpg');
          i++;
        });
        
      }
      xhr.send(formData);
    });
  }

  OcrInsuranceNew(fileFront: any, fileBack: any,isencrypted:any) {
    return Observable.create((observer: any) => {

      let formData: FormData = new FormData(),
        xhr: XMLHttpRequest = new XMLHttpRequest();

      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            observer.next(JSON.parse(xhr.response));
            observer.complete();
          } else {
            observer.error(xhr.response);
          }
        }
      };

      xhr.upload.onprogress = (event) => {
        this.progress = Math.round(event.loaded / event.total * 100);
        if (this.progressObserver)
          this.progressObserver.next(this.progress);
      };

      // Open the request to the specified URL
      xhr.open('POST', baseApiOCRNew, true);
      xhr.setRequestHeader('Authorization-key', 'e6GQY1XC2JmXtbfTzh0PB3RuMKUddgz1');
      formData.append('file1', fileFront);
      formData.append('file2', fileBack);
      formData.append('isEncrypted', isencrypted);

      // Send the form data
      xhr.send(formData);
    });
  }


  DeletePatientInsurance(data:any)
  {
    return this.GenericUtility.ApiPostMethodTalkphr("TalkCheckin","DeletePatientInsurance",data);
  }
  GetIsSelfPayOrInsurance(patient_account:any,practice_code:any)
  {
    return this.GenericUtility.ApiGetMethodTalkphr("TalkCheckin/GetPatientInsuranceData?PatientAccount="+patient_account+"&PracticeCode="+practice_code);
  }
  UpdatePatientSelfPayBit(data:any)
  {
    return this.GenericUtility.ApiPostMethodTalkphr("TalkCheckin","UpdatePatientSelfPayBit",data);
  }

  SavePatientInsurancePhoto(data: any) {
    return this.GenericUtility.ApiPostMethodTalkphr("TalkCheckin", "SaveInsurances_Photo", data);
  }
  SavePatientInsurancePhotoToEHR(data: any) {
    return this.GenericUtility.ApiPostMethodTalkphr("TalkCheckin", "SaveInsurances_Photo_EHR", data);
  }
  uploadAtFolder(files: File, folder: any, PATIENT_ACCOUNT: any, PRACTICE_CODE: any, ImageSubType:any) {

    return this.makeFileRequest(files, folder, PATIENT_ACCOUNT, PRACTICE_CODE, ImageSubType);
  }
  private makeFileRequest(files: File, folder: any, PATIENT_ACCOUNT: any, PRACTICE_CODE: any, ImageSubType:any): Observable<any> {
    return Observable.create((observer: any) => {
      let formData: FormData = new FormData(),
        xhr: XMLHttpRequest = new XMLHttpRequest();
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            observer.next(JSON.parse(xhr.response));
            observer.complete();
          } else {
            observer.error(xhr.response);
          }
        }
      };
      xhr.upload.onprogress = (event) => {
        this.progress = Math.round(event.loaded / event.total * 100);
        if (this.progressObserver)
          this.progressObserver.next(this.progress);
      };
      xhr.open('POST', this.GenericUtility.getBaseIpTalkPhr() + folder, true);
      // for (let i = 0; i < files.length; i++) {
      formData.append("PatientAccount", PATIENT_ACCOUNT);
      formData.append("PracticeCode", PRACTICE_CODE);
      formData.append("image", files);
      formData.append("ImageSubType", ImageSubType);
      //formData.append("uploads", files[i].name);
      //formData.append("size", files[i], files[i].size.toString());
      //formData.append("type", files[i], files[i].type);
      // }
      //add JWT token for save profile pic
      xhr.setRequestHeader('Authorization', "Bearer " + localStorage.getItem("AuthTokenwebServices"));
      xhr.send(formData);
    });
  }
}
